export default __webpack_public_path__ + "static/media/upi.e936907b.webp";